import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Instagram } from "lucide-react";
import { API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { photoUrl } from "@/lib/reviews";
import { INSTAGRAM, InstagramLinks } from "@/components/shop/Social";
import { Reveal } from "@/components/fx/Motion";

export const useInstagram = () => useQuery({ queryKey: ["instagram"], queryFn: () => axios.get(`${API}/instagram`).then((r) => r.data) });
const profile = (code) => INSTAGRAM.find((i) => i.code.toLowerCase() === code) || INSTAGRAM[2];

export const InstagramGallery = () => {
  const { t } = useI18n();
  const { data = [] } = useInstagram();
  if (!data.length) return null;
  return (
    <section data-testid="instagram-gallery" className="py-16 lg:py-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <p className="eyebrow mb-4">Instagram</p>
          <h2 className="font-display text-3xl lg:text-5xl">{t("ig_title")}</h2>
        </div>
        <InstagramLinks />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-1">
        {data.slice(0, 12).map((p, i) => (
          <Reveal key={p.id} delay={Math.min(i * 0.05, 0.4)}>
            <a data-testid={`instagram-post-${p.id}`} href={p.post_url || profile(p.account).href} target="_blank" rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden bg-white/5">
              <img src={photoUrl(p.image)} alt={`@${profile(p.account).handle}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <span className="absolute inset-0 flex items-center justify-center gap-2 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity text-xs">
                <Instagram size={18} className="text-gold" />@{profile(p.account).handle}
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
